export default __webpack_public_path__ + "images/EV.7f3fad9.png";